import axios from "axios";
const ROOT_API = "";

const Axios = axios.create({
  baseURL: ROOT_API
});

export default Axios;
